import { FiltersList } from "types/page-layout-types";

export type CallFeedbackItem = {
  id: string;
  user_id: string;
  call_session_id: string | null;
  rating: number;
  description: string | null;
  created_at: string;
  updated_at: string;
};

/** Full feedback as returned by GET by id (includes metadata) */
export type CallFeedbackDetail = CallFeedbackItem & {
  metadata?: Record<string, unknown> | null;
};

export type CallFeedbackListResponse = {
  feedbacks: CallFeedbackItem[];
  total_count: number;
  limit: number;
  offset: number;
};

export type CallFeedbackStats = {
  total_feedbacks: number;
  average_rating: number;
  rating_counts: Record<string, number>;
};

export const CallFeedbackFiltersList: FiltersList = {
  rating: [
    { name: "Все оценки", value: "", filter_name: "rating", disabled: false },
    { name: "1", value: "1", filter_name: "rating", disabled: false },
    { name: "2", value: "2", filter_name: "rating", disabled: false },
    { name: "3", value: "3", filter_name: "rating", disabled: false },
    { name: "4", value: "4", filter_name: "rating", disabled: false },
    { name: "5", value: "5", filter_name: "rating", disabled: false },
  ],
};
